/** Entra ID con MSAL (ADR-10): access token para appreg-skein-api (scope Studio.Access). */
import { InteractionRequiredAuthError, PublicClientApplication, type AccountInfo } from "@azure/msal-browser";
import { ENV } from "../env";
import { setLoginError } from "./loginState";

export const msal = new PublicClientApplication({
  auth: {
    clientId: ENV.clientId,
    authority: `https://login.microsoftonline.com/${ENV.tenantId}`,
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },
  cache: { cacheLocation: "sessionStorage" },
});
export const loginRequest = { scopes: [ENV.apiScope] };

export function activeAccount(): AccountInfo | null {
  return msal.getActiveAccount() ?? msal.getAllAccounts()[0] ?? null;
}
/** Token para la API: silencioso; si Entra pide interacción, redirige. */
export async function apiToken(): Promise<string> {
  const account = activeAccount();
  if (!account) throw new Error("sin sesión");
  try {
    return (await msal.acquireTokenSilent({ ...loginRequest, account })).accessToken;
  } catch (err) {
    // sesión caducada: Entra pide interacción → la puerta lo cuenta al volver
    setLoginError(err instanceof InteractionRequiredAuthError ? "caducada" : "red");
    await msal.acquireTokenRedirect(loginRequest);
    throw new Error("redirigiendo a Entra");
  }
}
export { initials } from "./initials";
